import { useTranslation } from 'react-i18next';
import EventsOverview from '../../components/EventsOverview/EventsOverview';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import LocationsMap from '../../components/LocationsMap/LocationsMap';
import Teaser from '../../components/Teaser/Teaser';
import TextBlock from '../../components/TextBlock/TextBlock';
import { useSystemDevice } from '../../hooks/useSystemDevice';
import homeAnimationData from '../../lottie/home.json';
import HeaderText from './HeaderText/HeaderText';
import './Home.scss';

function Home() {
  const scope = 'Home';
  const systemDevice = useSystemDevice();
  const { t } = useTranslation();

  const className = [scope, `${scope}--${systemDevice}`].join(' ');
  const mapText = t('locations_map_description');
  const mapTitle = t('locations_map_title');

  return (
    <div className={className}>
      <Header
        imageSrc={`${process.env.PUBLIC_URL}/media/home-${systemDevice}.jpg`}
      >
        <HeaderText />
      </Header>
      <div className={`${scope}-darkSection`}>
        <div className={`${scope}-content`}>
          <TextBlock
            className={`${scope}-halfWidth`}
            collapsedText={[
              'Starten Sie Ihre Ausflüge auf Sylt an der Buhne 16, hier erwarten Sie nicht nur kulinarischer Genuss und unsere Defender Lounge. Sie ist auch der Ausgangspunkt für all Ihre unvergesslichen Aktivitäten während Ihrer Defender Experience.',
              'Melden Sie sich jetzt für Ihre Aktivitäten an und genießen Sie eine faszinierende Reise entlang atemberaubender Küstenstraßen und wilder Dünenlandschaften auf Sylt.',
            ]}
            text="Erleben Sie unser robustestes SUV in seinem natürlichen Habitat. Bei der Defender Experience auf Sylt entdecken Sie jeden Winkel der Insel. Egal, ob Sie die traumhafte Nordseeinsel erkunden oder beim Kitesurfen Wind und Wasser trotzen. Der Defender macht den Weg zum Ziel und die Insel zu Ihrem Abenteuer."
            title="Ihre defender experience auf sylt"
          />
        </div>
      </div>
      <EventsOverview className={`${scope}-content`} />
      <LocationsMap
        animationData={homeAnimationData}
        showIntro={true}
        text={mapText}
        title={mapTitle}
      />
      <div className={`${scope}-darkSection`}>
        <div className={`${scope}-content`}>
          <Teaser
            buttonText="Jetzt Registrieren"
            imageSrc={`${process.env.PUBLIC_URL}/media/footer-${systemDevice}.jpg`}
            title="Sie wollen auf dem Laufenden bleiben? Dann kommt unser Newsletter genau richtig"
            url="https://forms.landrover.de/landr-de-de/servlet/SmartForm.html?formCode=lr-kmi2-de-de"
          />
        </div>
      </div>
      <div className={`${scope}-content`}>
        <Teaser
          className={`${scope}-teaser`}
          buttonText="Jetzt Entdecken"
          footnote="*Defender 90 D250 AWD Marine Blue Edition, Kraftstoffverbrauch und CO2-Emissionen nach WLTP (jeweils max. kombiniert): 8,7l/100km; 228g/100km"
          imageSrc={`${process.env.PUBLIC_URL}/media/teaser-${systemDevice}.jpg`}
          reverseDesktop={true}
          text="Darüber hinaus erwartet Sie ein ganz besonderes Highlight: der Defender 90 Marine Blue Limited Edition. Dieses Sammlerstück, limitiert auf 25 Exemplare, besticht durch seinen exklusiven Farbton – eine Hommage an die Geschichte des Defender."
          title="Streng limitiert"
          url="https://www.landrover.de/defender/defender/marine-blue-le.html"
        />
      </div>
      <Footer />
    </div>
  );
}

export default Home;
